import { Controller, useForm } from 'react-hook-form';
import { RadioGroup, RadioGroupItem } from 'src/components/ui/radio-group';
import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';
import { Button } from 'src/components/ui/button';

export const FreshdeskIntegrationForm1 = ({ freshdeskIntegrationType, nextStep, closePopup }) => {
  const submit = (data) => {
    nextStep(data);
  };

  const close = () => {
    closePopup();
  };

  const { handleSubmit, control } = useForm({
    defaultValues: {
      freshdeskIntegrationType: freshdeskIntegrationType,
    },
    resolver: yupResolver(
      object({
        freshdeskIntegrationType: stringScheme({ required: false }).label(
          'Freshdesk Integration Type',
        ),
      }),
    ),
  });

  return (
    <form
      onSubmit={handleSubmit(submit)}
      id="freshdesk-integration-form-1"
      className={'h-full flex flex-col justify-between'}
    >
      <Controller
        control={control}
        name="freshdeskIntegrationType"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <RadioGroup
            onChange={onChange}
            onValueChange={onChange}
            defaultValue={value}
            className="flex flex-col space-y-1"
          >
            <div className="flex items-center space-x-5 space-y-0 px-2.5 border border-[#E3E6E8] rounded-sm-5 hover:border-[#05050d4d]">
              <RadioGroupItem value={'Tickets'} id={`tickets`} />
              <label htmlFor={`tickets`} className="!ml-0 pl-3 w-full py-3.5">
                <p className="font-medium text-base text-ebony opacity-70 hover:opacity-100 transition">
                  Tickets
                </p>
              </label>
            </div>
            <div className="flex items-center space-x-5 space-y-0 px-2.5 border border-[#E3E6E8] rounded-sm-5 hover:border-[#05050d4d] opacity-70 pointer-events-none">
              <RadioGroupItem value={'Help Center'} id={`help-center`} disabled />
              <label htmlFor={`help-center`} className="!ml-0 pl-3 w-full py-3.5">
                <p className="font-medium text-base text-ebony opacity-70 hover:opacity-100 transition">
                  Help Center articles
                </p>
              </label>
            </div>
          </RadioGroup>
        )}
      />
      <div className="flex justify-center mt-5">
        <div className="flex gap-2.5">
          <Button variant="outline" type="button" className="min-w-24" onClick={close}>
            Cancel
          </Button>
          <Button type="submit" className="min-w-24">
            <span>Next</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="10"
              viewBox="0 0 9 10"
              fill="none"
              className="ml-1.5"
            >
              <path
                d="M0 5.5625L6.84562 5.5625L3.70125 8.70688L4.5 9.5L9 5L4.5 0.5L3.70687 1.29313L6.84562 4.4375L0 4.4375V5.5625Z"
                fill="white"
              />
            </svg>
          </Button>
        </div>
      </div>
    </form>
  );
};
